module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/136.bc97fe20.png";